<script>
import MealOption from '@/components/organism/restaurant/MealOption'
import Badge from '@/components/molecules/Badge'
import InputRadio from '@/components/atoms/inputlib/components/InputRadio'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import { mapGetters } from 'vuex'
export default {
    name: 'MealOptionGroup',
    components: { InputCheckbox, InputRadio, Badge, MealOption },
    props: {
        model: null,
        details: null,
        currency: null,
        hasError: Boolean,
        disabled: Boolean,
    },
    data() {
        return {
            selection: null,
            quantity: 0,
        }
    },
    computed: {
        ...mapGetters(['smDevice']),
        options() {
            return this.model?.options ? this.sortNull(this.model.options) : []
        },
        optional() {
            return this.model.min_quantity === 0
        },
        badgeText() {
            if (this.model.max_quantity === this.model.min_quantity && this.model.min_quantity) {
                return this.$t('meal.required_min_req', {
                    min: this.model.min_quantity,
                })
            } else if (
                this.model.max_quantity !== 1 &&
                this.model.max_quantity &&
                this.model.min_quantity
            ) {
                return this.$t('meal.required_min_max', {
                    min: this.model.min_quantity,
                    max: this.model.max_quantity,
                })
            } else {
                if (this.model.max_quantity)
                    return this.$t('meal.optional_max', {
                        max: this.model.max_quantity,
                    })
                if (this.model.min_quantity > 0)
                    return this.$t('meal.required_min', {
                        min: this.model.min_quantity,
                    })
            }
            return this.$t('meal.optional')
        },
        selectOne() {
            return this.model.max_quantity === 1
        },
        selectMultipleEachOne() {
            return this.model.max_each_quantity === 1 && this.model.max_quantity > 1
        },
        max() {
            return this.model.max_quantity > 0 ? this.model.max_quantity : undefined
        },
        min() {
            return this.model.min_quantity
        },
        maxEach() {
            return this.model.max_each_quantity > 0 ? this.model.max_each_quantity : undefined
        },
        minEach() {
            return this.model.min_each_quantity > 0 ? this.model.min_each_quantity : undefined
        },
        disableAdd() {
            return this.quantity >= this.max
        },
        test() {
            return this.max ? this.max - this.quantity : undefined
        },
        maxQuantity() {
            return this.maxEach ? this.maxEach : this.max
        },
        availableQuantity() {
            return this.test >= this.maxQuantity ? this.maxQuantity : this.test
        },
        quantitySelectorFloatRight() {
            return !this.options.find((option) => option.price > 0)
        },
    },
    methods: {
        getQuantity() {
            return this.selectOne
                ? this.selection
                    ? this.selection.quantity
                    : 0
                : this.selection && this.selection.length
                ? this.selection.reduce(
                      (accumulator, currentValue) =>
                          (accumulator.quantity ? accumulator.quantity : accumulator) +
                          currentValue.quantity,
                      0
                  )
                : 0
        },
        onInput() {
            this.quantity = this.getQuantity()
            this.$emit('select', {
                selection: this.selectOne
                    ? this.selection
                        ? this.setModel([this.selection])
                        : null
                    : this.setModel(this.selection),
                ready:
                    ((this.max ? this.quantity <= this.max : true) || this.optional) &&
                    this.min <= this.quantity,
            })
        },
        setModel(selection) {
            let result = []
            selection.forEach((option) => {
                result.push({
                    mealoption_id: option.id,
                    mealoption: this.details.getMealOption(option.id),
                    mealoptiongroup_id: this.model.id,
                    mealoptiongroup: this.details.getMealOptionGroup(this.model.id),
                    name: option.name,
                    price: option.price,
                    original_price: option.original_price,
                    quantity: option.quantity,
                })
            })
            return result
        },
    },
}
</script>

<template lang="pug">
.meal-option-group(v-if="model")
    .d-flex.justify-content-between.align-items-center.gap-2
        h2.my-0(:class="{'text-warning': hasError}") {{model.name}}
        badge(:type="hasError ? 'warning': optional ? 'secondary' : 'dark'" pill) {{ badgeText }}
    .text-73(v-if="model.description") {{ model.description }}
    meal-option(
        v-for="(option, index) in options"
        @input="onInput"
        v-model="selection"
        :class="{'border-top': index && smDevice}"
        :disabled="disabled"
        :model="option"
        :optional="optional"
        :currency="currency"
        :key="`mealOption-${index}`"
        :select-one="selectOne"
        :select-multiple-each-one="selectMultipleEachOne"
        :max="maxQuantity"
        :min="minEach"
        :no-price="quantitySelectorFloatRight"
        :available="availableQuantity"
        :disable-add="disableAdd")
</template>
